module.exports = __webpack_public_path__ + "img/shower-solid.bd619865.svg";